import axios from '../utils/axios';

export default function fetchPremiumRecruiters(adminId, params) {
    return (
        axios.get('/admin/' + adminId + '/premium-registered-recruiters', { params })
            .then(res => {
                return res.data
            })
            .catch(err => {
                return err;
            })
    )
}
